import { format, isSameDay, isToday, minutesToHours } from "date-fns";
import numeral from "numeral";

export function formatMobile(phoneNo) {
  if (!phoneNo) return "";

  // Remove any non-digit characters
  phoneNo = phoneNo.replace(/\D/g, "");
  if (phoneNo.startsWith("61")) {
    phoneNo = "0" + phoneNo.slice(2);
  }
  if (phoneNo.length !== 10) return phoneNo; // Return original if not 10 digits

  const formatNum = phoneNo.substr(0, 4) + " " + phoneNo.substr(4, 3) + " " + phoneNo.substr(7, 3);

  return formatNum;
}

export const jobFlagsOptions = ["jfComplete", "jfPickedUp", "jfIrreparable"];

export function normalCase(str) {
  if (typeof str !== "string" || str.length === 0) {
    return ""; // Handle empty strings or non-string inputs
  }
  // Convert the entire string to lowercase first
  str = str.toLowerCase();

  // Replace the first letter of each word with its uppercase version
  return str.replace(/\b\w/g, function (char) {
    return char.toUpperCase();
  });
}

export function truncateString(str, num) {
  if (str.length > num) {
    return str.slice(0, num);
  } else {
    return str;
  }
}

export function compareDatesOnly(date1, date2) {
  const d1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
  const d2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());

  if (d1.getTime() === d2.getTime()) {
    return 0; // Dates are equal
  } else if (d1.getTime() < d2.getTime()) {
    return -1; // date1 is earlier
  } else {
    return 1; // date1 is later
  }
}

export function translateSMSMessage(originalMsg, fName, sName, jobNo, itemName, total, balance, lDateTime) {
  let SMSText = originalMsg;
  //SMSText = SMSText.replace(new RegExp("[$FirstName]", "ig"), fName);
  SMSText = SMSText.replace("[$FirstName]", fName);
  SMSText = SMSText.replace("[$Surname]", sName);
  SMSText = SMSText.replace("[$JobNo]", "#" + jobNo);
  SMSText = SMSText.replace("[$ItemName]", itemName);
  SMSText = SMSText.replace("[$Total]", numeral(total ? total : 0).format("$0,0.00"));
  SMSText = SMSText.replace("[$Balance]", numeral(balance ? balance : 0).format("$0,0.00"));
  SMSText = SMSText.replace("[$ETA]", humanDate(lDateTime));

  //console.log("Translated SMS Text: ", SMSText);

  return SMSText;
}

export function humanDate(date) {
  var lDate = "on " + format(date, "dd/MM/yy");

  var lTime = "at " + format(date, "h:mm aa");

  const Tomorrow = new Date();
  Tomorrow.setDate(Tomorrow.getDate() + 1);

  if (isToday(date)) lDate = "today";
  if (isSameDay(date, Tomorrow)) lDate = "tomorrow";
  const lDateTime = lDate + " " + lTime;
  return lDateTime;
}

export const minutesToHoursExtended = (minutes) => {
  const hours = minutesToHours(minutes);
  const minutesLeft = (minutes - hours * 60).toFixed(0);
  const stringifiedHours = String(hours).length === 1 ? `${hours}` : `${hours}`;
  const stringifiedMinutes = String(minutesLeft).length === 1 ? `0${minutesLeft}` : `${minutesLeft}`;
  return `${stringifiedHours}:${stringifiedMinutes} hrs`;
};

export const minutesToHoursMinutesSeconds = (minutes) => {
  const totalSeconds = Math.floor(minutes * 60);
  const hours = Math.floor(totalSeconds / 3600);
  const mins = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;
  const pad = (n) => String(n).padStart(2, "0");
  return `${pad(hours)}:${pad(mins)}:${pad(secs)} hrs`;
};

const gameConsoles = [
  {
    name: "PlayStation 5",
    abbr: "PS5",
    id: "01",
    models: [
      { name: "10xx - First", id: "0A" },
      { name: "11xx - Second", id: "0B" },
      { name: "12xx - Third", id: "0C" },
      { name: "20xx - Slim", id: "0D" },
    ],
    drive: [
      { name: "Disc Drive Version", id: "DD" },
      { name: "Digital Version", id: "DG" },
    ],
  },
  {
    name: "PlayStation 4",
    abbr: "PS4",
    id: "02",
    models: [
      { name: "Standard (V1)", id: "0A" },
      { name: "Standard (V2)", id: "0B" },
      { name: "Slim", id: "0C" },
      { name: "Pro", id: "0D" },
    ],
  },
  {
    name: "Xbox One",
    abbr: "XOne",
    id: "03",
    models: [
      { name: "Xbox One", id: "0A" },
      { name: "Xbox One S", id: "0B" },
      { name: "Xbox One X", id: "0C" },
    ],
  },
  {
    name: "Xbox Series S/X",
    abbr: "XSeries",
    id: "04",
    models: [
      { name: "Series S", id: "0A" },
      { name: "Series X", id: "0B" },
    ],
  },
  {
    name: "Nintendo Switch",
    abbr: "NSwitch",
    id: "05",
    models: [
      { name: "Standard", id: "0A" },
      { name: "Lite", id: "0B" },
      { name: "OLED", id: "0C" },
    ],
  },
  {
    name: "PS5 Controller",
    abbr: "PS5C",
    id: "06",
    models: [
      { name: "Original", id: "0A" },
      { name: "Edge", id: "0B" },
    ],
  },
  {},
];

export const getGameConsoleId = (consoleName, modelName, driveType) => {
  const console = gameConsoles.find(
    (c) =>
      (c.name && c.name.toLowerCase() === String(consoleName).toLowerCase()) ||
      (c.abbr && c.abbr.toLowerCase() === String(consoleName).toLowerCase())
  );
  if (!console) return null;
  let model = null;
  if (console.models && modelName) {
    model = console.models.find((m) => m.name && m.name.toLowerCase() === String(modelName).toLowerCase());
  }
  let drive = null;
  if (console.drive && driveType) {
    drive = console.drive.find((d) => d.name && d.name.toLowerCase() === String(driveType).toLowerCase());
  }
  let id = console.id;
  if (model) {
    id += model.id;
  }
  if (drive) {
    id += drive.id;
  }
  return id;
};

export const gameConsoleList = () => {
  return gameConsoles
    .filter((c) => c.name)
    .map((c) => ({
      name: c.name,
      abbr: c.abbr,
      id: c.id,
      models: c.models ? c.models.map((m) => ({ name: m.name, id: m.id })) : [],
    }));
};

/**
 * Format a date in AU format, optionally with weekday
 * @param {Date|string|number} value - Date value
 * @param {Object} options - Options object
 * @param {boolean} options.weekday - Whether to include weekday (default true)
 * @returns {string}
 */
export function formatAUDate(value, { weekday = true } = {}) {
  if (!value) return "";
  const opts = {
    year: "2-digit",
    month: "2-digit",
    day: "2-digit",
  };
  if (weekday) opts.weekday = "short";
  return new Date(value).toLocaleDateString("en-AU", opts);
}

/**
 * Format a time in AU format
 * @param {Date|string|number} value - Date value
 * @returns {string}
 */
export function formatAUTime(value) {
  if (!value) return "";
  return new Date(value).toLocaleTimeString("en-AU", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
}

/**
 * Format a time in 24-hour format (HH:MM)
 * @param {Date|string|number} value - Date value
 * @returns {string}
 */
export function formatAUTime24(value) {
  if (!value) return "";
  return new Date(value).toLocaleTimeString("en-AU", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}
